var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 24,
    stroke: "#2667FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.372 25.588C27.0813 25.588 27.6973 25.4993 28.22 25.322C28.752 25.1446 29.186 24.902 29.522 24.594C29.8673 24.2766 30.124 23.9033 30.292 23.474C30.46 23.0446 30.544 22.5733 30.544 22.06C30.544 21.0333 30.2033 20.2446 29.522 19.694C28.85 19.1433 27.8187 18.868 26.428 18.868H24.02V25.588H26.372ZM36.06 36.2H32.658C32.014 36.2 31.5473 35.948 31.258 35.444L27.002 28.962C26.8433 28.7193 26.666 28.5466 26.47 28.444C26.2833 28.3413 26.0033 28.29 25.63 28.29H24.02V36.2H20.254V15.9559H26.428C27.8 15.9559 28.976 16.1006 29.956 16.39C30.9453 16.6699 31.7527 17.0666 32.378 17.58C33.0127 18.0933 33.4793 18.7093 33.778 19.428C34.0767 20.1373 34.226 20.9213 34.226 21.7799C34.226 22.4613 34.1233 23.1053 33.918 23.712C33.722 24.3186 33.4327 24.8693 33.05 25.364C32.6767 25.8586 32.21 26.2926 31.65 26.666C31.0993 27.0393 30.4693 27.3333 29.76 27.548C30.0027 27.688 30.2267 27.856 30.432 28.052C30.6373 28.2386 30.824 28.4626 30.992 28.724L36.06 36.2Z",
    fill: "#2667FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpr);
export default __webpack_public_path__ + "static/media/IPR.485ccd57844d31b89409ec06010ee8f5.svg";
export { ForwardRef as ReactComponent };